<div class="useful-link container-fluid p-0">
  <div class="link-name pl-3">{{usefulLink.displayName}}</div>
  <div class="link-controls pr-2">
    <a class="nav-link p-0 mr-3" [routerLink]="'./'" (click)="onEdit()">
      <span><i class="icon icon-edit" aria-hidden="true"></i></span>
    </a>
    <a class="nav-link p-0 mr-3" [routerLink]="'./'" (click)="onDelete()">
      <span><i class="icon icon-trash" aria-hidden="true"></i></span>
    </a>
  </div>
</div>
